import React, {useRef, useState, useEffect, useContext} from 'react';
import {Grid} from '@material-ui/core';
import {customStyle, overInputs} from './AccesibilidadStyle';
import { texts, properties, links } from './AccesibiliadData';
import {IconButton, ThemeProvider} from '@material-ui/core';
import {HelpOutlineRounded} from '@material-ui/icons'
import {properties as appProperties} from 'AppData';
import AppContext from 'AppContext';
import {properties as propertiesCloudConfig } from '../../../config/Config';
import AuthProvider from './../../../providers/authProvider';


export default function Accesibilidad() {  

    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const context = useContext(AppContext);
    const [nombreConsejeria, setNombreConsejeria] = useState();
    const {checkCloudProperties} = AuthProvider();
    const [ovUrl, setOvUrl] = useState();
    const [ovUrlMovil, setOvUrlMovil] = useState()
    
    const refIndice1 = useRef(null);
    const refIndice2 = useRef(null);
    const refIndice3 = useRef(null);
    const refIndice4 = useRef(null);
    const refIndice5 = useRef(null);
    const refIndice6 = useRef(null);

    useEffect (() =>{
        loadInfoCloud();
    },[]);

    const loadInfoCloud = async () =>{
        await checkCloudProperties(100);

        let consejeria = propertiesCloudConfig['CONSEJERIA_NOMBRE'];
        setNombreConsejeria(consejeria);
  
        let ovUrl = propertiesCloudConfig['CONSEJERIA_URL_OV'];
        let ovUrlMovil = ovUrl;
        if(ovUrl && ovUrl.length>47){
            ovUrlMovil = ovUrl.substring(0, 47).concat("...");
        }
        
        setOvUrl(ovUrl);
        setOvUrlMovil(ovUrlMovil)
    };

    /**
     * @function updateFormat Segun el num de pixeles del ancho de la pantalla pone version movil o version ordenador
     */
     const updateFormat = () => {
        if(window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    }

    /**
     * Obtiene el procedimiento en el que se encuentra para actualizar el
     * titulo de la pagina
     */
     const obtenerTituloPagina = () =>{
        context.updateTitlePage(texts.TEXT_TITULO_PAGINA);
    }


    /**Método que renderiza el paginador solo en versión ordenador */
    const renderIndice = () =>{
        
        return <Grid id='indice' className={isPhoneVersion ? customStyle().classGridIndiceResponsive : customStyle().classGridIndice}>
                <p className={customStyle().classTituloIndice}>{texts.TEXTO_INDICE}</p>
                <ol className={customStyle().classOlIndice}>
                    <li className={customStyle().classLiIndice} >
                        <a onClick={() => focusIndice(refIndice1)}>{texts.INDICE_1}</a>
                    </li>
                    <li className={customStyle().classLiIndice}>
                        <a onClick={() => focusIndice(refIndice2)}>{texts.INDICE_2}</a>
                    </li> 
                    <li className={customStyle().classLiIndice}>
                        <a onClick={() => focusIndice(refIndice3)}>{texts.INDICE_3}</a>
                    </li> 
                    <li className={customStyle().classLiIndice}>
                        <a onClick={() => focusIndice(refIndice4)}>{texts.INDICE_4}</a>  
                    </li> 
                    <li className={customStyle().classLiIndice}>
                        <a onClick={() => focusIndice(refIndice5)}>{texts.INDICE_5}</a>
                    </li>
                </ol>
            </Grid>
        
    }


    function focusIndice(param) {
        param.current.scrollIntoView();
    }

    useEffect(() => {
        updateFormat();
        obtenerTituloPagina();
    }, []);

    window.addEventListener('resize', updateFormat);

    return(
        <main>
            <Grid id='contenedor' className={isPhoneVersion ? customStyle().classGirdContainerResponsive : customStyle().classGirdContainer}>
                {isPhoneVersion && renderIndice()}
                <Grid id='texto' className={isPhoneVersion ? customStyle().classGridPrincipalResponsive : customStyle().classGridPrincipal}>
                    <Grid>
                        <h2 className={customStyle().classTituloPrincipal}>{texts.TITULO_PRINCIPAL}</h2>
                        <p className={customStyle().classParrafo}>
                            {"La "+nombreConsejeria+texts.TEXTO_PRINCIPAL_1}
                            <a href={links.LINK_BOE}>{texts.TEXTO_LINK_BIE}</a>
                        </p>
                        <p >
                            {texts.TEXTO_PRINCIPAL_2}
                            {isPhoneVersion ?
                                <a href={ovUrl} title={ovUrl}>{ovUrlMovil}</a>
                                : <a href={ovUrl}>{ovUrl}</a>
                            }
                        </p>
                    </Grid>
                    <Grid>
                        <h2 className={customStyle().classTituloSecundario} ref={refIndice1}>{texts.TITULO_CUMPLIMENTO}</h2>
                        <p className={customStyle().classParrafo}>{"La " + texts.OFICINA_VIRTUAL + texts.TEXTO_CUMPLIMENTO}</p>
                    </Grid>
                    <Grid>
                        <h2 className={customStyle().classTituloSecundario} ref={refIndice2}>{texts.TITULO_CONTENIDO}</h2>
                        <p className={customStyle().classParrafo}>{texts.TEXTO_CONTENIDO}</p>
                        <p className={customStyle().classParrafo}>{texts.TEXTO_CONTENIDO2}</p>
                        <ul className={customStyle().classOl}>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_CONTENIDO_1}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_CONTENIDO_2}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_CONTENIDO_3}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_CONTENIDO_4}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_CONTENIDO_5}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_CONTENIDO_6}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_CONTENIDO_7}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_CONTENIDO_8}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_CONTENIDO_9}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_CONTENIDO_10}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_CONTENIDO_11}
                            </li>
                            <li>
                                {texts.TEXTO_LIST_CONTENIDO_12}
                            </li>
                        </ul>
                    </Grid>
                    <Grid>
                        <h2 className={customStyle().classTituloSecundario} ref={refIndice3}>{texts.TITULO_CONFORMIDAD}</h2>
                        <p className={customStyle().classParrafo}>{texts.TEXTO_CONFORMIDAD_1}</p>
                    </Grid>
                    <Grid>
                        <h2 className={customStyle().classTituloSecundario} ref={refIndice4}>{texts.TITULO_OBSERVACIONES}</h2>
                        <p className={customStyle().classParrafo}>{texts.TEXTO_OBSERVACIONES_1}</p>
                        <ul className={customStyle().classUl}>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_OBSERVACIONES_1}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_OBSERVACIONES_2}
                            </li>
                            <li className={customStyle().classParrafo}>
                                {texts.TEXTO_LIST_OBSERVACIONES_3}
                            </li>
                        </ul>
                        <p className={customStyle().classParrafo}>{texts.TEXTO_OBSERVACIONES_2}<a href={links.LINK_EMAIL}>{texts.TEXTO_LINK_EMAIL}</a></p>
                        <p className={customStyle().classParrafo}>{texts.TEXTO_OBSERVACIONES_4}</p>
                    </Grid>
                    <Grid>
                        <h2 className={customStyle().classTituloSecundario} ref={refIndice5}>{texts.TITULO_APLICACION}</h2>
                        <p className={customStyle().classParrafo}>
                            {texts.TEXTO_APLICACION}
                            <a href={links.LINK_LIBRO_SUGERENCIAS}>{texts.TEXTO_LINK_LIBRO_SUGERENCIAS}</a>
                            {texts.TEXTO_APLICACION2}
                            <a href={links.LINK_SOLICITUD}>{texts.TEXTO_LINK_SOLICITUD}</a>
                            {texts.TEXTO_APLICACION3}
                            <a href={links.LINK_DOC}>{texts.TEXTO_LINK_FORMULARIO}</a>
                            {texts.TEXTO_APLICACION4}
                        </p>
                    </Grid>
                </Grid>
                {!isPhoneVersion && renderIndice()}
            </Grid>
        </main>    
    );
}
